/* Todaytec theme — minimal, dependency-free interactions */
(function () {
  'use strict';

  // Mobile navigation toggle
  var toggle = document.querySelector('[data-nav-toggle]');
  var nav = document.querySelector('[data-nav]');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var open = nav.getAttribute('data-open') === 'true';
      nav.setAttribute('data-open', String(!open));
      toggle.setAttribute('aria-expanded', String(!open));
    });
  }

  // Mega-menu: open on keyboard focus for touch/keyboard users
  document.querySelectorAll('[data-has-mega] > .nav__link').forEach(function (link) {
    link.addEventListener('click', function (e) {
      if (window.matchMedia('(max-width: 749px)').matches) {
        e.preventDefault();
        var item = link.parentElement;
        item.classList.toggle('is-open');
      }
    });
  });

  // Scroll reveal. The reference site ships gsap + ScrollTrigger + wow.js for this;
  // one observer does the same job. Elements opt in with data-reveal, and stagger
  // within a group via --reveal-delay.
  //
  // IntersectionObserver alone is NOT enough: an element the browser has already
  // scrolled PAST never intersects again, so a plain reload with restored scroll
  // position left whole bands permanently at opacity 0. A sweep therefore reveals
  // anything at or above the fold outright, and runs again on load and on scroll.
  window.__tdtRevealReady = true;
  var reveals = Array.prototype.slice.call(document.querySelectorAll('[data-reveal]'));
  if (reveals.length && 'IntersectionObserver' in window &&
      !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var pending = reveals.slice();
    var ro = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting && entry.boundingClientRect.top > 0) return;
        show(entry.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

    reveals.forEach(function (el, i) {
      // stagger siblings that share a parent, capped so long grids don't crawl
      el.style.setProperty('--reveal-delay', Math.min(i % 6, 5) * 70 + 'ms');
      ro.observe(el);
    });

    function show(el) {
      var i = pending.indexOf(el);
      if (i === -1) return;
      pending.splice(i, 1);
      el.classList.add('is-in');
      ro.unobserve(el);
      if (!pending.length) teardown();
    }

    // Anything already at or above the fold is shown immediately — no animation owed
    // for content the visitor is already looking at, or has scrolled past.
    function sweep() {
      var h = window.innerHeight;
      pending.slice().forEach(function (el) {
        if (el.getBoundingClientRect().top < h) show(el);
      });
    }
    var queued = false;
    function onScroll() {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; sweep(); });
    }
    function teardown() {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
      window.removeEventListener('load', sweep);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    // scroll restoration can land after this script runs, so sweep again on load
    window.addEventListener('load', sweep);
    sweep();
  } else {
    reveals.forEach(function (el) { el.classList.add('is-in'); });
  }

  // Animated counters for the metrics section
  var counters = document.querySelectorAll('[data-count-to]');
  if (counters.length && 'IntersectionObserver' in window &&
      !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        animate(entry.target);
        io.unobserve(entry.target);
      });
    }, { threshold: 0.4 });
    counters.forEach(function (el) { io.observe(el); });
  } else {
    counters.forEach(function (el) { el.textContent = format(el, +el.getAttribute('data-count-to')); });
  }

  function animate(el) {
    var target = +el.getAttribute('data-count-to');
    var start = performance.now();
    var dur = 1400;
    function step(now) {
      var t = Math.min((now - start) / dur, 1);
      var eased = 1 - Math.pow(1 - t, 3);
      el.textContent = format(el, Math.round(target * eased));
      if (t < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  function format(el, n) {
    var prefix = el.getAttribute('data-prefix') || '';
    var suffix = el.getAttribute('data-suffix') || '';
    return prefix + n.toLocaleString() + suffix;
  }
})();

/* Faceted portfolio filter
   Five facet groups on the ribbon-line pages. OR within a group, AND across groups.
   A product with no value for a facet is only hidden when THAT facet is filtered,
   so an unpopulated attribute never makes a product disappear from an unrelated filter. */
(function () {
  'use strict';
  var root = document.querySelector('[data-portfolio]');
  if (!root) return;
  var boxes = Array.prototype.slice.call(root.querySelectorAll('[data-facet]'));
  var cards = Array.prototype.slice.call(root.querySelectorAll('.pcard'));
  var reset = root.querySelector('[data-facet-reset]');
  var count = root.querySelector('[data-facet-count]');
  var empty = root.querySelector('[data-facet-empty]');
  if (!boxes.length || !cards.length) return;

  function apply() {
    var picked = {};
    boxes.forEach(function (b) {
      if (!b.checked) return;
      (picked[b.getAttribute('data-facet')] = picked[b.getAttribute('data-facet')] || []).push(b.value);
    });
    var groups = Object.keys(picked);
    var shown = 0;
    cards.forEach(function (card) {
      var ok = groups.every(function (g) {
        var have = (card.getAttribute('data-' + g) || '').split(' ').filter(Boolean);
        return picked[g].some(function (v) {
          // '__none__' is the explicit "no value for this facet" bucket. Without it,
          // ticking every real option in a group still hid the products the source
          // deliberately leaves ungraded, which reads as broken filtering.
          if (v === '__none__') return have.length === 0;
          return have.indexOf(v) > -1;
        });
      });
      card.hidden = !ok;
      if (ok) shown++;
    });
    if (reset) reset.hidden = !groups.length;
    if (empty) empty.hidden = shown !== 0;
    if (count) {
      count.textContent = groups.length
        ? (count.getAttribute('data-tpl') || '__N__').replace('__N__', shown)
        : '';
    }
  }

  boxes.forEach(function (b) { b.addEventListener('change', apply); });
  if (reset) reset.addEventListener('click', function () {
    boxes.forEach(function (b) { b.checked = false; });
    apply();
  });
  apply();
})();

/* Comparison tray
   Up to three products, state in sessionStorage so a shortlist survives navigating
   into a product and back. The full comparison payload is stored WITH the selection —
   /products/<handle>.js does not expose metafields, so a fetch could not rebuild the
   technical rows. */
(function () {
  'use strict';
  var KEY = 'tdt_compare';
  var MAX = 3;
  // Bump when the payload shape changes. A shortlist written by an older build is discarded
  // rather than rendered, so a visitor mid-session across a deploy cannot see a stale table.
  var VERSION = 2;
  var tray = document.querySelector('[data-compare-tray]');
  if (!tray) return;
  var slots = tray.querySelector('[data-compare-slots]');
  var hint = tray.querySelector('.cmp-tray__hint');
  var hintText = hint ? hint.textContent : '';
  var modal = document.querySelector('[data-compare-modal]');
  var table = modal ? modal.querySelector('[data-compare-table]') : null;

  function read() {
    try {
      var raw = JSON.parse(sessionStorage.getItem(KEY));
      if (!raw || raw.v !== VERSION || !Array.isArray(raw.items)) return [];
      return raw.items;
    } catch (e) { return []; }
  }
  function write(list) {
    try { sessionStorage.setItem(KEY, JSON.stringify({ v: VERSION, items: list })); } catch (e) {}
  }

  // The bottom-band contract needs the tray's real height, not a guess. I hardcoded the
  // measured 161px and the tray turned out to be 205px once three chips wrapped, which left
  // the PDPA notice overlapping its top edge by 13px — harmless today, but it grows with
  // longer model names and would eventually reach the buttons. Publish the measured value.
  function publishTrayHeight() {
    var h = tray.hidden ? 0 : Math.ceil(tray.getBoundingClientRect().height) + 12;
    document.documentElement.style.setProperty('--tdt-bb-tray', h + 'px');
  }

  function render() {
    var list = read();
    tray.hidden = list.length === 0;
    if (!slots) return;
    slots.innerHTML = '';
    list.forEach(function (item) {
      var chip = document.createElement('span');
      chip.className = 'cmp-slot';
      chip.innerHTML = '<b></b><button type="button" aria-label="remove">&times;</button>';
      chip.querySelector('b').textContent = item.model || item.handle;
      chip.querySelector('button').addEventListener('click', function () {
        write(read().filter(function (x) { return x.handle !== item.handle; }));
        syncBoxes();
        render();
      });
      slots.appendChild(chip);
    });
    for (var i = list.length; i < MAX; i++) {
      var ph = document.createElement('span');
      ph.className = 'cmp-slot cmp-slot--empty';
      slots.appendChild(ph);
    }
    publishTrayHeight();
  }
  window.addEventListener('resize', publishTrayHeight, { passive: true });

  function syncBoxes() {
    var handles = read().map(function (x) { return x.handle; });
    document.querySelectorAll('[data-compare]').forEach(function (b) {
      b.checked = handles.indexOf(b.value) > -1;
    });
  }

  document.querySelectorAll('[data-compare]').forEach(function (box) {
    box.addEventListener('change', function () {
      var list = read();
      if (box.checked) {
        if (list.length >= MAX) {
          box.checked = false;
          if (hint) {
            hint.textContent = hint.getAttribute('data-full') || hintText;
            hint.classList.add('is-warn');
            setTimeout(function () { hint.textContent = hintText; hint.classList.remove('is-warn'); }, 2200);
          }
          return;
        }
        var card = box.closest('.pcard');
        var payload = {};
        try { payload = JSON.parse(card.getAttribute('data-cmp')) || {}; } catch (e) {}
        payload.handle = box.value;
        payload.model = box.getAttribute('data-model') || payload.model;
        list.push(payload);
      } else {
        list = list.filter(function (x) { return x.handle !== box.value; });
      }
      write(list);
      render();
    });
  });

  var hide = tray.querySelector('[data-compare-hide]');
  if (hide) hide.addEventListener('click', function () { tray.hidden = true; publishTrayHeight(); });

  var run = tray.querySelector('[data-compare-run]');
  if (run && table && modal) {
    run.addEventListener('click', function () {
      var list = read();
      if (!list.length) return;
      var labels = {};
      try { labels = JSON.parse(tray.getAttribute('data-rows')) || {}; } catch (e) {}
      var rows = ['series', 'grade', 'method', 'substrate', 'speed', 'darkness', 'temp', 'scratch']
        .map(function (k) { return [k, labels[k] || k]; })
        .filter(function (r) {
        // only render a row some selected product actually has data for
        return list.some(function (p) { return p[r[0]]; });
      });
      var html = '<table class="cmp-table"><thead><tr><th></th>';
      list.forEach(function (p) {
        html += '<th><a href="' + (p.url || '#') + '">' + (p.model || p.handle) + '</a></th>';
      });
      html += '</tr></thead><tbody>';
      rows.forEach(function (r) {
        html += '<tr><th>' + r[1] + '</th>';
        list.forEach(function (p) { html += '<td>' + (p[r[0]] || '—') + '</td>'; });
        html += '</tr>';
      });
      html += '</tbody></table>';
      table.innerHTML = html;
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
      openModal();
    });
  }

  // aria-modal="true" is a promise to the assistive layer that focus cannot leave the
  // dialog. Without a trap the claim is false: Tab walks straight out into the page behind
  // the scrim, where nothing is clickable. Move focus in, keep it in, hand it back on close.
  var lastFocus = null;
  function focusables() {
    if (!modal) return [];
    return Array.prototype.slice.call(
      modal.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])')
    ).filter(function (el) { return el.offsetParent !== null; });
  }
  function openModal() {
    lastFocus = document.activeElement;
    var f = focusables();
    if (f.length) f[0].focus();
  }
  function trap(e) {
    if (!modal || modal.hidden || e.key !== 'Tab') return;
    var f = focusables();
    if (!f.length) return;
    var first = f[0];
    var last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    else if (!modal.contains(document.activeElement)) {
      // Focus is outside the dialog entirely — which happens as soon as the visitor clicks a
      // non-focusable part of the panel, because that moves activeElement to BODY. Without
      // this arm the next Tab is native and lands behind the scrim.
      e.preventDefault();
      (e.shiftKey ? last : first).focus();
    }
  }
  function closeModal() {
    if (!modal || modal.hidden) return;
    modal.hidden = true;
    document.body.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
    lastFocus = null;
  }
  var close = modal ? modal.querySelector('[data-compare-close]') : null;
  if (close) close.addEventListener('click', closeModal);
  if (modal) modal.addEventListener('click', function (e) { if (e.target === modal) closeModal(); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeModal();
    trap(e);
  });

  syncBoxes();
  render();
})();
